import TileSeries from './TileSeries'

export default TileSeries
// eslint-disable-next-line import/export
export * from './TileSeries'
